export default __webpack_public_path__ + "static/media/topwave-21.116d82b5.png";